import {apiGetCall, apiPostCall} from "./index";

export const load   = () => apiGetCall("/distributors/getall");
export const save   = (uuid, distributorDetails) => apiPostCall("/distributors/save", {uuid, ...distributorDetails});
export const remove = uuid => apiPostCall("/distributors/remove", {uuid});